import CircularProgress from '@mui/material/CircularProgress';
import { always, cond, propEq } from 'ramda';
import * as React from 'react';

import Button, { ButtonProps } from '@mui/material/Button';
import { withStyles, createStyles } from 'src/components/core/styles';

import HelpIcon from 'src/components/HelpIcon';

export interface Props extends ButtonProps {
  loading?: boolean;
  type?: 'submit' | 'reset' | 'button' | undefined;
  className?: string;
  tooltipText?: string;
  compact?: boolean;
  variant?: any;
  textClassName?: string;
}

const styles = () =>
  createStyles({
    root: {
      background: 'var(--button-background-color)',
      color: 'var(--button-color) !important',
      borderRadius: 'var(--button-border-radius) !important',
      fontSize: '18px',
      paddingLeft: '1.75rem !important',
      paddingRight: '1.75rem !important',
      letterSpacing: '-0.02em !important',
      textAlign: 'center',
      verticalAlign: 'middle !important',
      userAselect: 'none !important',
      paddingTop: '0.375rem !important',
      paddingBottom: '0.375rem !important',
      lineHeight: '2.75rem!important',
      fontFamily: 'inherit !important',
      fontWeight: 400,
      border: `var(--button-border-size) solid var(--button-border-color)`,
      '&:hover': {
        border: `var(--button-border-hover-size) solid var(--button-border-color-hover)`,
        color: 'var(--button-color-hover) !important',
        backgroundColor: 'var(--button-background-color-hover) !important',
      },
    },
    primary: {
      background: 'var(--main-primary-color) !important',
    },
    compact: {
      paddingLeft: 14,
      paddingRight: 14,
    },
    hidden: {
      visibility: 'hidden',
    },
    reg: {
      display: 'flex !important',
      alignItems: 'center !important',
    },
  });

type CombinedProps = Props;

const getVariant: any = cond([
  [propEq('type', 'primary'), always('raised')],
  [propEq('type', 'secondary'), always('raised')],
  [() => true, always(undefined)],
]);

// Add invariant warning if loading destructive cancel
// Add invariant warning if destructive cancel

const wrappedButton: React.StatelessComponent<CombinedProps> = (props) => {
  const {
    loading,
    tooltipText,
    type,
    compact,
    className,
    textClassName,
    ...rest
  } = props;
  const classes = {
    root: 'root',
    loading: 'loading',
    primary: 'primary',
    compact: 'compact',
    hidden: 'hidden',
    reg: 'reg',
  };
  return (
    <React.Fragment>
      <Button
        {...rest}
        variant={getVariant(props)}
        disabled={props.disabled || loading}
        className={`${type} btn btn-custom text-white ${classes.root} ${compact ? classes.compact : ''} ${className}`}
      >
        {loading ? (
          <div className="loading-wrap loading-btn">
            <CircularProgress size={18} thickness={3} />
          </div>
        ) : (
          <span className={`${classes.reg} ${textClassName}`}>
            {props.children}
          </span>
        )}
      </Button>
      {tooltipText && <HelpIcon text={tooltipText} />}
    </React.Fragment>
  );
};

const styled = withStyles(styles);
export default styled(wrappedButton);
